<template>
  <h-inspection-page
    :title="h_i18n('20982bbcdd7c5b929f427f654ea93f59')"
    @inspection-update="inspectionUpdate"
  >
    <!-- title-width="5" -->
    <form-header :title="h_i18n('20982bbcdd7c5b929f427f654ea93f59')">
      <!-- <template #title>
          <h-p align="left" title="表号">{{ data.DetailsInfo.patternPlanId }}</h-p>
          <h-p align="left" title="生效日期">{{ time(data.DetailsInfo.isrtDate,6) }}</h-p>
        </template> -->
      <template #body>
        <tr>
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="3:9">
            <span>{{ data.DetailsInfo.supplyCode }}</span>
          </report-td>
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="3:9">
            <span>{{ data.DetailsInfo.supplyName }}</span>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('ad539fd028219141d81a234286f290a8')" colspan="3:9">
            <span>{{ data.DetailsInfo.guarantyNo }}</span>
          </report-td>
          <report-td :title="h_i18n('6265d095fda40520557a7c9d3a92d2c0')" colspan="3:9">
            <span>{{ time(data.DetailsInfo.signDate, 3) }}</span>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('383a6d166f8f60e16e726ccc9c483631')" colspan="3:9">
            <span>{{ data.DetailsInfo.materielCategoryName }}</span>
          </report-td>
          <report-td :title="h_i18n('d503a29b7898f3f97ac773c542a70eb1')" colspan="3:9">
            <!-- <span
              class="h-global-font--blue"
              @click="
                downLoadFile(data.DetailsInfo.UUID, data.DetailsInfo.fileName)
              "
              >{{ data.DetailsInfo.fileName }}</span
            > -->
            <div v-if="data.DetailsInfo.fileId">
              <span
                class="h-global-font--blue"
                @click="
                  downLoadFile(
                    data.DetailsInfo.fileId,
                    data.DetailsInfo.fileName
                  )
                "
              >
                {{ data.DetailsInfo.fileName }}
              </span>
            </div>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('ae27d6f465386eb63210704c8918c6c4')" colspan="3:9">
            <span>{{ data.DetailsInfo.inputName }}</span>
          </report-td>
          <report-td :title="h_i18n('0039880117c13787732d259f5bc9f7f5')" colspan="3:9">
            <span>{{ time(data.DetailsInfo.inputDate, 6) }}</span>
          </report-td>
        </tr>
        <tr>
          <!-- <report-td title="审核人" colspan="3:9">
            <span>{{ data.DetailsInfo.reviewName }}</span>
          </report-td> -->
          <report-td :title="h_i18n('8c4ab5982fcea30b260715ac494e7922')" colspan="3:9">
            <span v-if="data.DetailsInfo.reviewResult == 'W'">{{ h_i18n('5cb424765cb101866f47ca115605ce3b') }}</span>
            <span v-else-if="data.DetailsInfo.reviewResult == 'P'"
              >{{ h_i18n('871a30c0993c4e2a71557fe7f38807c0') }}</span>
            <span v-else-if="data.DetailsInfo.reviewResult == 'F'"
              >{{ h_i18n('b748ef6566aff87d0f677e431a2038b0') }}</span>
          </report-td>
          <report-td :title="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" colspan="3:9">
            <span>{{ time(data.DetailsInfo.reviewDate, 6) }}</span>
          </report-td>
        </tr>
        <tr>
          <!-- <report-td title="审核结论" colspan="3:9">
            <span v-if="data.DetailsInfo.reviewResult == 'W'">待审核</span>
            <span v-else-if="data.DetailsInfo.reviewResult == 'P'"
              >审核通过</span
            >
            <span v-else-if="data.DetailsInfo.reviewResult == 'F'"
              >审核打回</span
            >
          </report-td> -->
          <report-td :title="h_i18n('ab1bcd732b932ead763bf080d90e93ab')" colspan="3:21">
            <span>{{ data.DetailsInfo.reviewReason }}</span>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('2432b57515b3627faddccb1dd1df206e')" colspan="3:21">
            <span>{{ data.DetailsInfo.remark }}</span>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('1bbbb204023e59eba03319c7c5848fd1')" colspan="3:21">
            <div style="color: red;font-size: 12px;">
              <p>{{ h_i18n('d848a36eedf516d714dc06ab46fd558c') }}</p>
              <p>{{ h_i18n('27d9a20033921818e1ff70818004d461') }}</p>
              <p>{{ h_i18n('676f2b994cdb44efda8f546e5301fca1') }}</p>
              <p style="text-indent: 10px;">{{ h_i18n('c5b91036b4e2d299b8f372bc6dc8cdad') }}</p>
              <p style="text-indent: 10px;">{{ h_i18n('36C1F9B35EC2ACE67A4C6156C3F22C25') }}</p>
              <p style="text-indent: 58px;">{{ h_i18n('b260dbf964e8868a75a51f5aaf0b8ffe') }}</p>
              <p style="text-indent: 58px;">{{ h_i18n('533e964b2babbbce2dc1e4e0db509b7a') }}</p>
            </div>
          </report-td>
        </tr>
      </template>
    </form-header>
    <div style="padding-top:10px;padding-bottom:10px;">
      <h-button-group align="center">
        <h-button type="default" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
      </h-button-group>
    </div>
  </h-inspection-page>
</template>


<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onActivated } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
const { proxy } = getCurrentInstance();
const route = useRoute();
const data = reactive({
  name: "", // 用户账号
  nickName: "", // 用户昵称
  loading: false, // 表单提交加载
  submitLoading: false,
  envId: "",
  dataTableList: [],
  DetailsInfo: {}, // 详情信息
});
const downLoadFile = (UUID, fileName) => {
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'));
  let suffix = UUID.includes("mkhl/");
  if (suffix) {
    // let url = "/tosqmfordown/readFile/" + UUID;
    let url = "/base/fileDownload/downloadFile?filePath=" + UUID;
    proxy.httpFile(
      {
        method: "get",
        url: url,
        headers: { "content-type": "application/json" },
      },
      fileName
    );
  } else {
    // http://sqm-test.qd-huangdao-test.haier.net/hmqm/tosqmfordown/downLoadFileNew?type=6&fileUUID=2020/01/18/870a742d-25b8-4f75-87a3-236fd0e93a28.pdf
    let url = `/base/fileDownload/downLoadFileFtp?type=6&fileUUID=${UUID}`;
    // let url = `/tosqmfordown/downLoadFileNew?type=6&fileUUID=${UUID}`;
    proxy.httpFile(
      {
        method: "get",
        url: url,
        headers: { "content-type": "application/json" },
      },
      fileName
    );
  }
};
const getDetails = () => {
  console.log(data.infoId);
  proxy
    .$http({
      // /environmentWithHMQM/getDetailById
      url: "/base/environmentWithHMQM/getDetailById",
      method: "get",
      params: {
        envId: data.envId,
      },
    })
    .then((res) => {
      console.log(res, "查询详情");
      if (res.data.code == 200) {
        data.DetailsInfo = res.data.data;
      } else {
        data.DetailsInfo = {};
        proxy.warning({
          message: res.data.msg ? res.data.msg : h_i18n('21efd88b67a39834582ad99aabb9dc60'),
          title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'),
        });
      }
    });
};

const inspectionUpdate = () => {
  proxy.postThisPageHeight();
};
onMounted(() => {
  if (route.query) {
    data.supplyCode = route.query.supplyCode;
    data.supplyName = route.query.supplyName;
    data.trueName = route.query.trueName;
    data.username = route.query.username;
    data.roleCode = route.query.roleCode;
    data.envId = route.query.envId;
    getDetails();
  }
});
</script>

<style scoped lang="scss">
.h-hwork-form-header {
  padding: 0;
}

:deep(.haier-table-header--right) {
  position: unset !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.haier-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.haier-text-right {
  text-align: right;
}

.haier-cell:hover {
  white-space: normal;
  word-break: break-all;
}
</style>